<template>
  <div class="page-footer">
    <template v-if="templateId === 104">
      <footer class="t1-ft"
              id="t1-ft">
        <div class="section-wrap t1-ft-grid">
          <div>
            <div class="kakobuy-promo-visual pc-image3">
              <img v-if="homeContent?.pcImage3"
                   :src="homeContent?.pcImage3"
                   alt="FINDS packaging boxes"
                   loading="lazy" />
            </div>
            <p v-for="(info, index) in websiteInfo"
               :key="`website-info-${index}`">
              {{ info }}
            </p>

            <p style="margin-top: 20px">
              {{ siteDomain }} © 2026
            </p>
          </div>
        </div>
      </footer>
    </template>

    <template v-if="templateId === 103">
      <div class="footer-card"
           v-if="homeContent?.pcImage2 || statementContent">
        <div class="footer-logo-wrap">
          <img v-if="homeContent?.pcImage2"
               width="220"
               height="80"
               :src="homeContent?.pcImage2"
               class="footer-logo"
               alt="footer-logo">
        </div>
        <div class="footer-statement"
             v-html="statementContent"></div>
      </div>

      <div class="footer-copyright">
        Copyright 2026 {{ siteDomain }} - All Rights Reserved
      </div>
    </template>

    <template v-else-if="templateId === 101">
      <div class="footer-inner">
        <div class="footer-brand-text">
          {{ footer.brand }}
        </div>
        <p class="footer-desc">
          {{ footer.desc }}
        </p>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PageFooter',

  data() {
    return {
    }
  },

  computed: {
    templateId() {
      return JSON.parse(sessionStorage.getItem('homeData')).templateId || ''
    },
    homeContent() {
      return JSON.parse(sessionStorage.getItem('homeData')).homeContent || {}
    },

    websiteInfo() {
      return this.homeContent?.title5?.split('##').filter(Boolean) || []
    },

    statementContent() {
      return this.homeContent?.title4?.split('##').join('<br>')
    },
    siteDomain() {
      if (typeof window === 'undefined') {
        return ''
      }
      return window.location.hostname || ''
    },

    footer() {
      const arr = this.homeContent?.title3?.split('##') || []

      if (arr.length > 0) {
        return {
          brand: arr[0] || '',
          desc: arr[1] || ''
        }
      }

      return {
        brand: '',
        desc: ''
      }
    },
  },
}
</script>

<style scoped lang="scss">
/* 101 模板页脚样式 */
.footer-inner {
  max-width: 100%;
  padding: 56px 32px 32px;
  display: block;
  border-top: 1px solid var(--select-border-color);
}

.footer-brand-text {
  margin-bottom: 8px;
  font-size: 20px;
  font-weight: 800;
}

.footer-desc {
  color: var(--select-color);
  font-size: 13px;
  line-height: 1.7;
  margin-bottom: 0;
}

/* 103 模板页脚样式 */
.page-footer {
  padding: 36px 0 0;
  background: var(--background-color);
}

/* Main glowing card */
.footer-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  max-width: 100%;
  min-height: 170px;
  margin: 0 auto;
  padding: 26px 56px;
  border: 2px solid var(--primary-color);
  border-radius: 36px;
  background: var(--background-color);
  box-shadow: 0px 0px 50px 0px var(--primary-color);
}

.footer-logo-wrap {
  flex: 0 0 auto;
}

.footer-logo {
  display: block;
  width: 200px;
  height: auto;
  object-fit: contain;
}

.footer-statement {
  width: 50%;
  font-weight: 900;
  color: var(--select-color);
  font-size: 12px;
  line-height: 1.7;
  text-align: center;
  white-space: normal;
}

.footer-copyright {
  font-family: 'Montserrat', Sans-serif;
  font-size: 1em;
  font-weight: 900;
  color: var(--select-color);
  margin: 18px 0;
  text-align: center;
}

@media (max-width: 991px) {
  .footer-card {
    flex-direction: column;
    min-height: 0;
    padding: 20px 20px;
    text-align: center;
  }

  .footer-logo {
    width: 170px;
  }

  .footer-copyright {
    font-size: 20px;
  }
}
</style>